import * as z from "zod";

export const getAeoPromptSummary = {
  name: "getAeoPromptSummary" as const,
  input: z.object({ promptId: z.bigint() }),
  output: z.object({ summary: z.string() }),
};
